import React from "react";

const EditTravelPartner = () => {
  return (
    <>
      <form className="text-left">
        <div className="form-group">
          <label htmlFor="exampleInputComapanyName">Name</label>
          <input
            type="text"
            className="form-control"
            id="exampleInputComapanyName"
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputImage">Image</label>
          <input type="file" className="form-control" id="exampleInputImage" />
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Save
        </button>
      </form>
    </>
  );
};

export default EditTravelPartner;
